import * as actionType from './type';
import { getRequestData, searchRequestData } from '../../Utility/apiHelper';
import { requestHideLoader, requestShowLoader } from '../Global/action';

export const requestGetAllStatus = (authToken) => async(dispatch) => {
    try {
        
        dispatch({
            type: actionType?.REQUEST_GET_ALL_STATUS
        })
        const responseData = await getRequestData(`lookup/?type=leadstatus`);
        const sortedStatus = responseData?.data.sort((item, nextIntem) =>  item?.sequence - nextIntem?.sequence);
        dispatch({
            type: actionType.RECEIVED_GET_ALL_STATUS,
            payload: sortedStatus
        })
    } catch(error) {

    }

}

export const requestUpdateFilterList = (payloaddata) => async(dispatch) => {
    try {
        dispatch({
            type: actionType.SET_FILTERD_OPTIONLIST,
            payload: payloaddata
        })
    } catch(error) {

    }
}

export const requestgetleads = (queryparams) => async(dispatch) => {
    dispatch(requestShowLoader())
    try {
            const leadSearchUrl = `${process.env.REACT_APP_BASE_URL}leads`;
            const responsedata = await searchRequestData(queryparams , leadSearchUrl , false)
        dispatch({
            type: actionType.RECEIVED_ALL_LEADS,
            payload: responsedata?.data
        })
        
    } catch(error) {
    }
    dispatch(requestHideLoader())
}

export const requestGetLeadsPaged = (queryparams) => async(dispatch) => {
    dispatch({ type: actionType.REQUEST_GET_PAGED_LEADS })
    dispatch(requestShowLoader())
    try {
        const leadPagedUrl = `${process.env.REACT_APP_BASE_URL}leads/paged`;
        const responsedata = await searchRequestData(queryparams, leadPagedUrl, false)
        dispatch({
            type: actionType.RECEIVED_PAGED_LEADS,
            payload: responsedata?.data
        })
    } catch(error) {
    }
    dispatch(requestHideLoader())
}

export const requestGetLeadSuccessPredictionData = (leadId) => async(dispatch) => {
    dispatch(requestShowLoader())
    try {
            const leadSearchUrl = `${process.env.REACT_APP_BASE_URL}api/scores?lead_id=${leadId}`;
            const responsedata = await getRequestData(leadSearchUrl)
        dispatch({
            type: actionType.RECEIVED_LEAD_SUCCESS_PREDICTION_DATA,
            payload: responsedata?.data
        })
        
    } catch(error) {
    }
    dispatch(requestHideLoader())
}